import React, { Component } from 'react'
import {
  CLOUDINARY_API_KEY,
  CLOUDINARY_NAME,
} from '../../../constants/images/cloudinary'
import moment from 'moment'
import cloudinary from 'cloudinary-core'
import { MAP_SIZES_TO_PROPS } from '../../../constants'
import withSizes from 'react-sizes'
import ConditionalLink from '../../elements/conditionalLink'
import { compose } from 'recompose'
import { buildBikeURL } from '../../utils'
import { Columns, Image, Header } from '../../elements'
import './reviews.css'
import ReviewImages from './ReviewImages'
const cl = new cloudinary.Cloudinary({
  cloud_name: CLOUDINARY_NAME,
  //upload_preset : CLOUDINARY_VEHICLE_PRESET,
  api_key: CLOUDINARY_API_KEY,
})

class BikeProfileReviews extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showLocation: true,
      // images: [
      //   {
      //     bike_image_url:
      //       'https://cdn.pixabay.com/photo/2016/03/27/17/59/motorcycle-1283299_960_720.jpg',
      //   },
      //   {
      //     bike_image_url:
      //       'https://cdn.pixabay.com/photo/2016/11/29/10/21/dirt-bike-1868996_960_720.jpg',
      //   },
      //   {
      //     bike_image_url:
      //       'https://cdn.pixabay.com/photo/2019/05/08/01/52/motorcycle-4187586_960_720.jpg',
      //   },
      //   {
      //     bike_image_url:
      //       'https://cdn.pixabay.com/photo/2014/04/23/20/34/dirt-bike-330815_960_720.jpg',
      //   },
      //   {
      //     bike_image_url:
      //       'https://cdn.pixabay.com/photo/2021/10/17/18/55/motorcycle-6719182_960_720.jpg',
      //   },
      // ],
    }
  }

  componentDidMount() {
    if (this.props.reviewUserLocation.city === '') {
      this.setState({ showLocation: false })
    }
  }

  render() {
    // const { isMobile } = this.props
    return (
      <div className="review-block">
        <Columns breakpoint={'mobile'} className="mb-0">
          <Columns.Column
            mobile={{
              size: 2,
            }}
            tablet={{
              size: 1,
            }}
          >
            <ConditionalLink
              active={this.props.reviewAuthorActive}
              url={'/users/' + this.props.reviewUserID}
            >
              <Image
                src={cl.url(this.props.reviewAvatar, {
                  gravity: 'center',
                  crop: 'fill',
                  format: 'jpg',
                  quality: 'auto',
                  height: 75,
                  width: 75
                })}
                rounded
                alt={this.props.reviewName}
              />
            </ConditionalLink>
          </Columns.Column>
          <Columns.Column
            style={{ position: 'relative' }}
            mobile={{
              size: 10,
            }}
            tablet={{
              size: 112,
            }}
          >
            <div className="is-align-items-center is-flex review-name">
              <span className="is-inline-block mr-1 has-text-weight-bold">
                {this.props.reviewName}
              </span>
              {/* <RatingStars
                rating={this.props.reviewRating}
                size="small"
                showInfo={false}
              /> */}
              <div className="is-paragraph-text">
                {moment(this.props.reviewDate).format('MMMM Do, YYYY')}
              </div>
            </div>
            {/* {this.state.showLocation && (
              <div className="is-size-7">
                from {this.props.reviewUserLocation.city},{' '}
                {this.props.reviewUserLocation.region_abbreviation}
              </div>
            )} */}
            {this.props.reviewMotoLocation &&
              !this.props.isMobile &&
              this.props.showMotorcycleLink && (
                <div className="review-bike-link is-size-7">
                  <ConditionalLink
                    active={this.props.reviewMotoActive}
                    url={buildBikeURL({
                      country: this.props.reviewMotoLocation
                        .country_abbreviation,
                      region: this.props.reviewMotoLocation.region_abbreviation,
                      city: this.props.reviewMotoLocation.city,
                      year: this.props.reviewYear.toString(),
                      make: this.props.reviewBikeMake,
                      model: this.props.reviewBikeModel,
                      bikeID: this.props.reviewBikeID,
                    })}
                  >
                    <span>
                      {this.props.reviewYear} {this.props.reviewBikeMake}{' '}
                      {this.props.reviewBikeModel}
                    </span>{' '}
                    <i className="fas fa-arrow-right"></i>
                  </ConditionalLink>
                </div>
              )}
          </Columns.Column>
        </Columns>
        <Columns className="review-body">
          <Columns.Column
            mobile={{
              size: 10,
              offset: 2,
            }}
            tablet={{
              size: 12,
              offset: 1,
            }}
          >
            {this.props.reviewBikeBody && (
              <div className="mb-4">
                {this.props.reviewOwnerBody && (
                  <div className="bike-renter-wrap">
                    <i className="fas fa-motorcycle fa-2x"></i>
                    <div className="review-header-container">
                      <Header renderas="h3" size={7} className="mb-0">
                        Bike
                      </Header>
                      {this.props.reviewRating && (
                        <p className="renter-bike-rating">
                          {this.props.reviewRating + ' '}
                          <i className="fa fa-star bike-profile-bike-rating"></i>
                        </p>
                      )}
                    </div>
                  </div>
                )}
                <p className="mb-3 is-paragraph-text">
                  {this.props.reviewBikeBody}
                </p>
                <ReviewImages
                  isMobile={this.props.isMobile}
                  review={this.props.review}
                />
              </div>
            )}
            {/* {this.props.reviewOwnerBody && (
              <div>
                {this.props.reviewBikeBody && (
                  <Header renderas="h3" size={7} className="mb-0">
                    Owner
                  </Header>
                )}
                <p className="has-black-dark-text">{this.props.reviewOwnerBody}</p>
              </div>
            )} */}
            {this.props.reviewOwnerBody && (
              <div className="mb-4">
                {this.props.reviewBikeBody && (
                  <div className="bike-owner-wrap-container">
                    <i className="fas fa-user fa-2x"></i>
                    <div className="owner-header-container">
                      <Header renderas="h3" size={7} className="mb-0">
                        Owner
                      </Header>
                      {this.props.ownerRating && (
                        <p className="owner-bike-rating">
                          {this.props.ownerRating + ' '}
                          <i className="fa fa-star bike-profile-bike-rating"></i>
                        </p>
                      )}
                    </div>
                  </div>
                )}
                <p className="mb-3 is-paragraph-text">
                  {this.props.reviewOwnerBody}
                </p>
              </div>
            )}

            {this.props.reviewMotoLocation &&
              this.props.isMobile &&
              this.props.showMotorcycleLink && (
                <div className="col-md-6 review-bike-link is-size-7">
                  <ConditionalLink
                    active={this.props.reviewMotoActive}
                    url={buildBikeURL({
                      country: this.props.reviewMotoLocation
                        .country_abbreviation,
                      region: this.props.reviewMotoLocation.region_abbreviation,
                      city: this.props.reviewMotoLocation.city,
                      year: this.props.reviewYear.toString(),
                      make: this.props.reviewBikeMake,
                      model: this.props.reviewBikeModel,
                      bikeID: this.props.reviewBikeID,
                    })}
                  >
                    <span>
                      {this.props.reviewYear} {this.props.reviewBikeMake}{' '}
                      {this.props.reviewBikeModel}
                    </span>{' '}
                    <i className="fas fa-arrow-right"></i>
                  </ConditionalLink>
                </div>
              )}
          </Columns.Column>
        </Columns>
      </div>
    )
  }
}

export default compose(withSizes(MAP_SIZES_TO_PROPS))(BikeProfileReviews)

BikeProfileReviews.defaultProps = {
  showMotorcycleLink: true,
}
